export default class ConstructionSiteResource {
  constructor(client) {
    this.client = client;
  }

  list() {
    return this.client.get("/construction_sites").then((resp) => resp.data);
  }

  create(construction_site) {
    return this.client
      .post("/construction_sites", construction_site)
      .then((resp) => resp.data);
  }

  find(id) {
    return this.client
      .get("/construction_sites/" + id)
      .then((resp) => resp.data);
  }

  delete(id) {
    return this.client.delete("/construction_sites/" + id).then((resp) => resp);
  }

  create_marker(id, marker) {
    return this.client
      .post("/construction_sites/" + id + "/markers", marker)
      .then((resp) => resp.data);
  }

  delete_marker(id, marker_id) {
    return this.client.delete(
      "/construction_sites/" + id + "/markers/" + marker_id
    );
  }
}
